import React from 'react'
import _ from 'lodash'
import {Avatar} from 'antd'
import {MdChurch} from 'react-icons/md'
import {RiMapPinFill} from 'react-icons/ri'
import {FaUserTie} from 'react-icons/fa6'
import {GiPrayer} from 'react-icons/gi'
import Translate from 'modules/local/Translate'
import {renderIf} from 'views/Shared'
// Tái dùng ĐÚNG enum đã có của phân hệ Dòng Tu (renderReligiousOrderSearchItem.js đang dùng y hệt) -
// không tự chế lại nhãn giới tính/bản chất riêng cho lookup, tránh 2 nguồn nhãn lệch nhau.
import {TargetGenderTypes} from '../../ReligiousOrder/components/ReligiousOrderForm'
import {NatureTypeInfos} from '../../ReligiousOrder/consts/NatureTypes'

// renderOption dùng chung cho mọi LookupField giáo xứ trong Family Book (FamilyBooks.js,
// EditFamilyBookModal.js, MemberDetailModal.js) - show thêm phân cấp Giáo hạt/Giáo phận/Tổng giáo
// phận để phân biệt các giáo xứ trùng tên, thay vì chỉ hiện mỗi tên như renderOptDefault gốc của
// LookupField (default renderer không show hint cho _type khác 'profile').
export const renderParishLookupOption = (o, i) => {
    const {fullname, deanery_fullname, diocese_fullname, archdiocese_fullname, location_address} = o ?? {}
    const hierarchy = [deanery_fullname, diocese_fullname, archdiocese_fullname].filter(Boolean).join(' • ')
    return (
        <div key={i} className="flex items-center flex-1 gap-3">
            <Avatar
                size={40}
                src={o.cover_photo}
                className="flex flex-center background-200 rounded-lg flex-shrink-0"
                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
            />
            <div className="flex flex-col flex-1 min-w-0 gap-0.5">
                <span className="font-medium text-sm text-color-000 leading-snug truncate">{fullname}</span>
                {renderIf(
                    hierarchy,
                    <span className="text-xs text-blue-500 italic leading-snug truncate">{hierarchy}</span>
                )}
                {renderIf(
                    location_address,
                    <div className="flex items-center gap-x-1">
                        <RiMapPinFill size={11} className="text-color-400 flex-shrink-0"/>
                        <span className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">{location_address}</span>
                    </div>
                )}
            </div>
        </div>
    )
}

// renderOption dùng chung cho mọi LookupField tên thánh trong Family Book (MemberDetailModal.js,
// FamilyBookDetail.js) - show thêm ngày kính (feast_day, đã có sẵn từ backend) để phân biệt các vị
// thánh trùng tên đọc.
export const renderSaintLookupOption = (o, i) => (
    <Translate key={i}>
        {(t) => (
            <div className="flex items-center gap-3 flex-1">
                <Avatar
                    size={36}
                    src={o.avatar}
                    icon={<FaUserTie size={14} className="text-color-500"/>}
                    className="flex flex-center background-200 flex-shrink-0"
                />
                <div className="flex flex-col flex-1 min-w-0">
                    <span className="text-sm font-medium text-color-000 leading-snug truncate">{t(o.label)}</span>
                    {renderIf(
                        o.feast_day,
                        <span className="text-2xs text-color-400 italic leading-tight truncate">
                            {`${t('feast day')}: ${o.feast_day}`}
                        </span>
                    )}
                </div>
            </div>
        )}
    </Translate>
)

// renderOption dùng chung cho LookupField dòng tu trong Family Book (MemberDetailModal.js - form
// Ơn Gọi Thánh Hiến) - list tra cứu có nhiều dòng TRÙNG/GẦN TÊN nhau (vd nhiều nhánh cùng 1 dòng gốc
// ở nhiều quốc gia), chỉ hiện mỗi tên không đủ phân biệt - bổ sung đủ 3 trường phân loại cùng lúc
// (giới tính/bản chất/thuộc dòng lớn nào) để chọn đúng ngay, không cần bấm vào xem chi tiết mới biết.
// Dữ liệu đã có sẵn từ BE (ReligiousOrderTransformerBasic - LookupController::religious_order case),
// chỉ thiếu UI hiển thị.
export const renderReligiousOrderLookupOption = (o, i) => {
    const genderLabel = _.find(TargetGenderTypes, {value: o.target_gender})?.label
    const natureLabel = _.find(NatureTypeInfos, {value: o.nature_typecd})?.label
    // "Thuộc dòng tu lớn" - ưu tiên parent (dòng gốc cụ thể, vd nhánh Việt Nam thuộc dòng Đa Minh
    // quốc tế) vì chính xác hơn religious_order_group (chỉ là nhãn nhóm chung chung, vd "Dòng Nam").
    const parentLabel = o.parent?.name || o.religious_order_group

    return (
        <Translate key={i}>
            {(t) => (
                <div className="flex items-start flex-1 gap-3">
                    <Avatar
                        size={40}
                        src={o.avatar}
                        className="flex flex-center background-200 rounded-lg flex-shrink-0"
                        icon={<GiPrayer size={18} style={{color: '#dddddd'}}/>}
                    />
                    <div className="flex flex-col flex-1 min-w-0 gap-1">
                        <span className="font-medium text-sm text-color-000 leading-snug truncate">{o.name}</span>
                        {(genderLabel || natureLabel) && (
                            <div className="flex flex-wrap items-center gap-1">
                                {renderIf(
                                    genderLabel,
                                    <span className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-blue-50 text-blue-600 leading-tight">
                                        {t(genderLabel)}
                                    </span>
                                )}
                                {renderIf(
                                    natureLabel,
                                    <span className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-color-100 text-color-400 leading-tight">
                                        {t(natureLabel)}
                                    </span>
                                )}
                            </div>
                        )}
                        {renderIf(
                            parentLabel,
                            <span className="text-2xs text-color-400 italic leading-snug truncate">
                                {`${t('the branch congregation of')}: ${parentLabel}`}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}
